"use strict";
(() => {
  const root = document.querySelector('[data-tx-report]');
  if (!root) return;
  const labels = JSON.parse(document.querySelector('#tx-report-labels').textContent);
  const select = root.querySelector('[data-tx-provider]');
  const confirm = root.querySelector('[data-tx-confirm]');
  const error = root.querySelector('[data-tx-error]');
  const query = new URLSearchParams(location.search);
  const requested = (query.get('provider') || '').replace(/^tx_/, '');
  if ([...select.options].some(o => o.value === requested)) select.value = requested;
  const render = () => {
    for (const panel of root.querySelectorAll('[data-tx-panel]')) panel.hidden = panel.dataset.txPanel !== select.value;
    confirm.closest('label').hidden = ['other', 'well'].includes(select.value);
    error.hidden = true;
  };
  select.addEventListener('change', () => { confirm.checked = false; render(); });
  confirm.addEventListener('change', () => { error.hidden = confirm.checked; });
  for (const button of root.querySelectorAll('[data-tx-choose]')) button.addEventListener('click', () => {
    select.value = button.dataset.txChoose; confirm.checked = false; render();
    select.focus(); document.querySelector('#tx-provider-area').scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
  });
  for (const a of root.querySelectorAll('[data-tx-next]')) a.addEventListener('click', event => {
    if (!['other','well'].includes(select.value) && !confirm.checked) {
      event.preventDefault(); error.hidden = false; confirm.focus();
      document.querySelector('#tx-provider-area').scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});return;
    }
    const url = new URL(root.dataset.matchUrl, location.origin);
    url.searchParams.set('provider',['other','well'].includes(select.value)?select.value:'tx_'+select.value);
    const zip = query.get('zip');
    if (/^\d{5}$/.test(zip || '') && typeof ClearhouseWaterData !== 'undefined' && ClearhouseWaterData.zipCounties[zip]?.includes(root.dataset.county)) url.searchParams.set('zip',zip);
    url.searchParams.set('txreport','1');
    a.href = url.href;
  });
  for (const input of root.querySelectorAll('[data-tx-search]')) input.addEventListener('input', () => {
    const details = input.closest('details'), term = input.value.trim().toLocaleLowerCase();let count=0;
    for (const row of details.querySelectorAll('[data-tx-row]')) {row.hidden = !row.textContent.toLocaleLowerCase().includes(term); if (!row.hidden) count++;}
    details.querySelector('[data-tx-result-status]').textContent = count ? count+' '+labels.results : labels.empty;
  });
  root.querySelector('[data-tx-copy]').addEventListener('click',async () => {
    const url = new URL(location.href);url.hash='';url.searchParams.set('provider',['other','well'].includes(select.value)?select.value:'tx_'+select.value);
    try {await navigator.clipboard.writeText(url.href);root.querySelector('[data-tx-copy-status]').textContent=labels.copied;}
    catch {root.querySelector('[data-tx-copy-status]').textContent=labels.fallback;}
  });
  render();
})();
